import React, { createContext, useContext, useState, useEffect } from "react";
import { login as apiLogin, User, LoginResponse } from "../api/api"; // <- User und LoginResponse importieren

// LOKALEN User-Typ ENTFERNEN
// type User = {
//   username: string;
//   role: "admin" | "user";
//   customerName: string;
//   customerId: string;
// };

type AuthContextType = {
  user: User | null; // Nutzt den importierten User-Typ
  token: string | null;
  login: (username: string, password: string) => Promise<boolean>;
  logout: () => void;
};

const AuthContext = createContext<AuthContextType>({
  user: null,
  token: null,
  login: async () => false,
  logout: () => {},
});

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [user, setUser] = useState<User | null>(null); // Nutzt den importierten User-Typ
  const [token, setToken] = useState<string | null>(null);

  // Lade Session aus localStorage
  useEffect(() => {
    const savedToken = localStorage.getItem("token");
    const savedUser = localStorage.getItem("user");
    if (savedToken && savedUser) {
      try {
        const parsedUser: User = JSON.parse(savedUser); // EXPLIZITER CAST HIER
        setUser(parsedUser);
        setToken(savedToken);
      } catch (e) {
        console.error("Fehler beim Parsen des gespeicherten Benutzers:", e);
        // Bei Fehler im localStorage aufräumen
        localStorage.removeItem("token");
        localStorage.removeItem("user");
      }
    }
  }, []);

  // ECHTER Login
  const login = async (username: string, password: string) => {
    try {
      const res: LoginResponse = await apiLogin(username, password); // Expliziter Typ für res
      setUser(res.user);
      setToken(res.token);
      localStorage.setItem("token", res.token);
      localStorage.setItem("user", JSON.stringify(res.user));
      return true;
    } catch (err) {
      console.error("Login-Fehler:", err);
      setUser(null);
      setToken(null);
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      return false;
    }
  };

  const logout = () => {
    setUser(null);
    setToken(null);
    localStorage.removeItem("token");
    localStorage.removeItem("user");
  };

  return (
    <AuthContext.Provider value={{ user, token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
export { AuthContext };
export default AuthProvider;